/*                                             */
import { CLEAN, CONNECTED, DIRTY, MAYBE_DIRTY } from '#client/constants';

const STATUS_MASK = ~(DIRTY | MAYBE_DIRTY | CLEAN);

/**
 *
 *
 */
export function set_signal_status(signal, status) {
	signal.f = (signal.f & STATUS_MASK) | status;
}

/**
 *
 *
 */
export function update_derived_status(derived) {
	/*                                                             */
	if ((derived.f & CONNECTED) !== 0 || derived.deps === null) {
		set_signal_status(derived, CLEAN);
	} else {
		set_signal_status(derived, MAYBE_DIRTY);
	}
}
